export default "__VITE_ASSET__BAAoF8gm__"